<template>
  <!-- 企业介绍 -->
  <div>
    <!-- banner -->
    <img src="../../static/about/about.png" alt="img" class="img" />
    <!-- 关于我们 -->
    <div class="about-wrap">
      <div class="about-title">关于我们</div>
      <div class="about-sub-title">ABOUT US</div>
      <div class="about-content">
        <div class="content-left">
          <div class="content-title">飞碟科技</div>
          <div class="content-sub-title">USPACE TECHNOLOGY</div>
          <div class="content">{{ comDesc }}</div>
        </div>
        <img src="../assets/aboutUs.png" alt="img" class="content-right" />
      </div>
    </div>
    <!-- 荣誉 -->
    <div class="honor-wrap">
      <div class="honor-content-wrap">
        <div class="honor-title">资质荣誉</div>
        <div class="honor-sub-title">QUALIFICATION HONOR</div>
        <img src="../assets/honor.webp" alt="img" class="img" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      comDesc:
        "飞碟科技（北京）有限公司位于望京SOHO，杭州公司位于萧山区奥景名邸，是健康体检中心全流程业务系统解决方案服务商，服务于全国各级健康体检中心，为健康体检中心提供信息化软件以及运营管理咨询服务。",
    };
  },
};
</script>

<style lang="less" scoped>
.about-wrap {
  width: 1200px;
  margin: 0 auto;
  padding-top: 60px;
  .about-title {
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-bottom: 14px;
  }
  .about-sub-title {
    text-align: center;
    font-size: 26px;
    font-weight: 300;
    color: #153578;
    margin-bottom: 74px;
  }
  .about-sub-title::after {
    content: "";
    width: 30px;
    height: 3px;
    background: #153578;
    display: block;
    margin: 20px auto 0;
  }
  .about-content {
    display: flex;
    margin-bottom: 73px;
    .content-left {
      box-sizing: border-box;
      margin-right: 50px;
      .content-title {
        font-size: 22px;
        font-weight: 400;
        color: #333333;
      }
      .content-sub-title {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        margin-bottom: 66px;
      }
      .content {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        text-indent: 32px;
      }
    }
    .content-right {
      width: 546px;
    }
  }
}
// 荣誉
.honor-wrap {
  width: 100%;
  min-height: 1200px;
  background: rgba(222, 222, 222, 0.31);
  .honor-content-wrap {
    width: 1165px;
    margin: 0 auto;
    padding-top: 74px;
    padding-bottom: 108px;
    .honor-title {
      font-size: 32px;
      font-family: Microsoft YaHei, serif;
      font-weight: 400;
      color: #333333;
      text-align: center;
      margin-bottom: 15px;
    }
    .honor-sub-title {
      font-size: 26px;
      font-family: Microsoft YaHei, serif;
      font-weight: 400;
      color: #153578;
      text-align: center;
      margin-bottom: 30px;
    }

    .honor-sub-title::after {
      content: "";
      width: 30px;
      height: 3px;
      background: #153578;
      display: block;
      margin: 20px auto 0;
    }
  }
}
.img {
  width: 100%;
}
</style>
